
/* injects from baggage-loader */

/*global NODE_ENV*/
'use strict';

import developmentConstant from './development.constants';
import productionConstant from './production.constants';
import testConstant from './test.constants';

/**
 * Constants to use in the application depending of the environment used.
 *
 * @export
 * @param {AngularModule} app
 */
export default function (app) {

	/**
	 * Constants definition for the all server.
	 */
	const utilitiesConstants = {
		COMPONENTS: {
			BOX: {
				CODE_ATTR: 'boxCode',
				PLURAL: 'Cajas',
				TITLE: 'Cajas',
				TYPE: '1'
			},
			BUNDLE: {
				CODE_ATTR: 'bundleCode',
				PLURAL: 'Fajos',
				TITLE: 'Fajos',
				TYPE: '2'
			},
			STRIP: {
				CODE_ATTR: 'stripCode',
				PLURAL: 'Tiros',
				TITLE: 'Tiros',
				TYPE: '3'
			},
			TICKET: {
				CODE_ATTR: 'scratchTicket',
				PLURAL: 'Raspas',
				TITLE: 'Raspas',
				TYPE: '4'
			}
		},
		CONFIRM: {
			TITLE: '¿Estás seguro?',
			CANCEL: '¡No podrás recuperar los datos sin guardar!',
			DELETE: '¡No podrás recuperar el registro eliminado!'
		},
		/**
		 * In the directive the keys are in lowercase
		 */
		PAGINATE: {
			of: 'de',
			page: 'Página:',
			rowsPerPage: 'Filas por página:'
		},
		PAGINATE_OPTION: [5, 10, 25, 50, 100],
		PATTERN_REGEX: {
			COMPONENT_CODE: '\\d+',
			NAME: '[\\w ñÑáÁéËíÍóÓúÚ]+'
		},
		PROFILE: {
			ADMIN: 'ADMIN',
			CASHIER: 'CASHIER',
			COMPANY: 'COMPANY',
			SELLER: 'SELLER'
		},
		REFRESH_TOOLTIP: 'Recargar datos de la tabla.',
		URL_API_METHOD: {
			ALL_OFFICES: '/process-component/all-offices',
			ALL_SELLERS_CASHIERS: '/process-component/all-office-users/:userId',
			AUTHENTICATION: '/authentication',
			ASSIGN_COMPONENT: {
				COMPONENTS: '/assign-component/component/:componentCode/:componentType',
				ASSIGN_COMPONENTS_OFFICE: '/assign-component/office/:officeCode',
				ASSIGN_COMPONENTS_USER: '/assign-component/user/:salesmancode/:office/:name/:identification/:profile'
			},
			CAMPAIGNS: '/process-component/campaigns',
			CAMPAIGN_MANAGEMENT: {
				AVAILABLE_EMISSIONS: '/campaign/available-emissions',
				AVAILABLE_PRIZES: '/campaign/available-prizes',
				CREATE_CAMPAIGN: '/campaign/create-campaign',
				DELETE_CAMPAIGN: '/campaign/delete-campaign/:campaignId',
				DOWNLOAD_EMISSIONS: '/campaign/download-new-emissions',
				DOWNLOAD_PRIZES: '/campaign/download-new-prizes',
				GET_CURRENT_CAMPAIGNS: '/campaign/current-campaigns',
				EDIT_CAMPAIGN: '/campaign/edit/:campaignId',
				UPDATE_CAMPAIGN: '/campaign/update-campaign/:campaignId'
			},
			CONFIRM: '/confirmed-component',
			CONFIRM_COMPONENTS: '/pending-to-confirm-component/confirm',
			CONFIRM_COMPANY: {
				CONFIRM_COMPONENT_COMPANY: '/pending-confirm-company/confirm-component-company',
				GET_AVAILABLE_COMPONENT: '/pending-confirm-company/get-list-component-to-company'
			},
			CONFIRM_OFFICE: {
				AVAILABLE_COMPONENT: '/pending-to-confirm-office/available-component',
				CONFIRM_COMPONENTS: '/pending-to-confirm-office/confirm'
			},
			DOWNLOAD_USER_MANUAL: '/process-component/download-user-manual',
			FILE_MANAGEMENT: {
				GET_FILES: '/file-management/get-files',
				DOWNLOAD_FILE: '/file-management/download-report-file'
			},
			LOCK_UNLOCK_COMPONENTS: {
				LOCKABLE: '/lock-unlock/lockable-components',
				LOCK_COMPONENTS: '/lock-unlock/lock-components',
				STATUSES: '/lock-unlock/statuses',
				UNLOCKABLE: '/lock-unlock/unlockable-components',
				UNLOCK_COMPONENTS: '/lock-unlock/unlock-components'
			},
			LOGOUT: '/logout',
			MANAGEMENT_USER: {
				USER: '/user-access/users',
				UNLOCKED: '/user-access/user/unlock'
			},
			OFFICES: '/process-component/offices',
			PENDING_COMPONENTS: '/pending-to-confirm-component',
			SELLERS_CASHIERS: '/process-component/office-users/:userId',
			EMISSIONS_BY_CAMPAIGN_ID: '/process-component/emissions/:campaignId',
			COMPONENT_TYPES: '/process-component/component-types',
			GENERATE_REPORT: '/report/:reportType',
			GENERATE_FILE: '/report/download/:reportType',
			RETURN_COMPONENT: {
				GET_COMPONENT_TO_RETURN: '/return-component/component/:userid/:componentCode/:processType',
				TYPE_RETURN: '/return-component/return-types',
				REGISTER_RETURN: '/return-component/register-return/:salesmancode/:office/:name/:identification/:profile',
			},
			RETURN_COMPANY: {
				REGISTER_RETURN_COMPANY: '/return-component-to-company/register-return-company',
				GET_RETURN_COMPANY: '/return-component-to-company/get-components/:componentCode/:ComponentType',
				RETURN_TYPE: '/return-component/return-types'
			},
			STATUSES: '/process-component/statuses',
			TYPES: '/process-component/report-types',
			PROCESS_STATUSES: '/process-component/process-status'
		},
		USER_MANUAL_FILE_NAME: 'Manual_Raspita.pdf'
	};

	/**
	 * UtilConstant definition depending of the environment used.
	 */
	const constants = NODE_ENV === 'production' ? productionConstant
		: (NODE_ENV === 'test' ? testConstant : developmentConstant);

	app.constant('utilitiesConstant', Object.assign(constants, utilitiesConstants));
}



// WEBPACK FOOTER //
// ./src/app/core/constants/utilities.constant.js